"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyUnitPackage = void 0;
function makeEmptyUnitPackage() {
    return {
        id: 0,
        description: '',
        order: 0,
        isDefault: false,
    };
}
exports.makeEmptyUnitPackage = makeEmptyUnitPackage;
//# sourceMappingURL=UnitPackage.js.map